var _style, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyLogisticToolkit04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FCBC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.5,57.1c-2.5,0-5,0-7.6,0c0.1,1.9-0.4,3.6-2,4.8C67,62.7,65.9,63,64.7,63c-2.3-0.1-5.1-1.9-4.9-5.9 c-4,0-2.3,0-6.5,0c0.1,1.9-0.4,3.5-1.8,4.7c-1,0.9-2.1,1.2-3.4,1.2c-2.6-0.1-5-2.3-4.9-5.8c-1.7,0-15.4,0-17.1,0 c0.2,4-2.7,5.9-5,5.9c-2.5,0-5.3-2-5-5.9c-1.5,0-3,0-4.5,0c0-1.5,0-3,0-4.4c19.3,0,39.2,0,47.3,0c0-6.5,0-13,0-19.4 c0.3,0,0.5,0,0.7,0c4.3,0,8.5,0,12.8,0c0.5,0,0.7,0.1,0.9,0.6c1.3,3,2.6,6,3.9,8.9c0.1,0.2,0.2,0.4,0.4,0.6 C77.5,47.9,77.5,52.5,77.5,57.1z M74.2,43.3c0-0.1,0-0.2-0.1-0.3c-0.9-2.2-1.8-4.3-2.8-6.5c-0.1-0.4-0.5-0.5-0.9-0.5 c-2.6,0-5.3,0-7.9,0c-0.6,0-0.6,0.2-0.6,0.6c0,1.9,0,4,0,5.9c0,0.2,0,0.4,0.1,0.6C66.2,43.3,70.3,43.3,74.2,43.3z M21.2,59.8 c1.1,0,1.9-0.9,1.9-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2.1C19.2,59,20.1,59.8,21.2,59.8z M48.3,59.8c1.1,0,2-0.9,2-2 c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2C46.3,58.9,47.3,59.8,48.3,59.8z M64.9,59.8c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2.1 C63,59,63.8,59.8,64.9,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,25.5c14.8,0,29.5,0,44.1,0c0,8.4,0,16.8,0,25.2c-14.8,0-29.5,0-44.1,0C12.7,42.3,12.7,33.8,12.7,25.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.2,36.1c-4.4,1.2-9.6,1.7-14.3,1.7s-9.9-0.5-14.3-1.7l-0.8,3.5c3.1,0.9,6.7,1.4,10.1,1.7v22.2h3.3V53.2 h3.4v10.3H40V41.3c3.4-0.3,7-0.9,10.1-1.7L49.2,36.1z M34.9,36.1c1.8,0,3.4-1.6,3.4-3.5s-1.6-3.5-3.4-3.5s-3.4,1.6-3.4,3.5 C31.5,34.5,33.1,36.1,34.9,36.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLogisticToolkit04);
export default __webpack_public_path__ + "static/media/my-logistic-toolkit-04.95f64d67fb2e54855658affdbe9e956e.svg";
export { ForwardRef as ReactComponent };